import * as utils from "../js/utils/utils";

$(document).ready(function () {
  // Prepend General Message Banner to Header
  $(".generalmessage").prependTo("header");
  utils.createBurgerTogle();

  // =======================
  // MISC SCRIPTS
  // =======================
  $(window).load(function () {
    $(".header .navMobileMenuShiftedGoBack").remove();
  });
});

